import $ from 'jquery';
import initSwiper from '../utils/swiper';
import gsap from 'gsap';
import {ajaxRequest} from '../utils/ajax';

// ajax
import axios from 'axios';
import qs from 'qs';

// common
import common from '../utils/common';

const home = {
	grid: null,
	slide_nb: null,
	dest_actual: null,
	popularDest: null,
	heightminPopular: null,
	popularProductsSwiper: null,
	owl: null,
	lastMinuteSlides: [],
	lastMinuteFilters: {
		destination: 'all',
		duration: 'all',
	},

	init() {
		if (!window.navigatorUtils.checkMobile()) {
			this.slide_nb = 1;
			// galerie.init(this.slide_nb, ".slide_bg", ".slide_infos", ".__nav_slides > li", true);
		}
		//this.map();
		this.lastminutes();
		this.initCategories();
		this.initExperiences();
		this.initCarousels();
		this.popularDestionations();
		//this.partners();
	},

	initCategories() {
		$(document).on('mouseover', '.__bl_category', function () {
			const category = $(this).data('cat');
			$(`.__background[data-cat!=${category}]`).removeClass('_show');
			$(`.__background[data-cat=${category}]`).addClass('_show');
		});
	},

	initExperiences() {
		const updateSectionNavIndicator = (nav) => {
			const active = nav ? nav.querySelector('.__section_nav_tab._activ') : null;

			if (!nav || !active) {
				return;
			}

			const navRect = nav.getBoundingClientRect();
			const activeRect = active.getBoundingClientRect();
			nav.style.setProperty('--section-nav-indicator-left', `${activeRect.left - navRect.left + nav.scrollLeft}px`);
			nav.style.setProperty('--section-nav-indicator-width', `${activeRect.width}px`);
		};

		const updateAllSectionNavIndicators = () => {
			document.querySelectorAll('.__section_nav').forEach(updateSectionNavIndicator);
		};

		updateAllSectionNavIndicators();
		window.addEventListener('resize', updateAllSectionNavIndicators);

		$(document).on('click', '.__experience_tab', function () {
			const category = $(this).data('cat');

			$(".__experience_tab").removeClass("_activ").attr("aria-selected", "false");
			$(this).addClass("_activ").attr("aria-selected", "true");
			updateSectionNavIndicator(this.closest('.__section_nav'));

			$(".__experience_panel").removeClass("_activ");
			$(`.__experience_panel[data-cat="${category}"]`).addClass("_activ");
			document.querySelectorAll('.__experience_products_swiper').forEach((swiper) => {
				if (swiper.swiper) {
					swiper.swiper.update();
				}
			});
		});

		document.querySelectorAll('.__section_nav').forEach((nav) => {
			nav.addEventListener('scroll', () => updateSectionNavIndicator(nav), {passive: true});
		});
	},

	initCarousels() {


		initSwiper('.__home_categories', {
			loop: false,
			autoHeight: false,
			slidesPerView: '5',
			spaceBetween: 10,
			navigation: true,
			autoplay: true,
			breakpoints: {
				0: {slidesPerView: '1.8'},
				640: {slidesPerView: '2.3'},
				768: {slidesPerView: '4'},
				1024: {slidesPerView: '5'},
			},
		});

		document.querySelectorAll('.__experience_products_swiper').forEach((swiper) => {
			const panel = swiper.closest('.__experience_panel');
			const prevBtn = panel?.querySelector('.__experience_products_prev');
			const nextBtn = panel?.querySelector('.__experience_products_next');

			const instance = initSwiper(swiper, {
				loop: false,
				autoHeight: false,
				slidesPerView: 4,
				spaceBetween: 20,
				navigation: Boolean(prevBtn && nextBtn),
				navigationEls: (prevBtn && nextBtn) ? {prevEl: prevBtn, nextEl: nextBtn} : null,
				autoplay: false,
				watchOverflow: true,
				// Meme logique que .__popular_products_swiper (page d'accueil,
				// "Top Picks Of the Season") : un apercu (0.3) du slide suivant en
				// grand ecran pour signaler qu'il y a plus a naviguer avec les
				// fleches.
				breakpoints: {
					0: {slidesPerView: 1.15, spaceBetween: 14},
					640: {slidesPerView: 2.05, spaceBetween: 16},
					993: {slidesPerView: 3.2, spaceBetween: 20},
					1300: {slidesPerView: 4.3, spaceBetween: 20},
				},
			});

			if (prevBtn && nextBtn && instance) {
				const updateNavigationState = () => {
					prevBtn.classList.toggle('_disabled', instance.isBeginning);
					nextBtn.classList.toggle('_disabled', instance.isEnd);
				};

				instance.on('slideChange', updateNavigationState);
				instance.on('resize', updateNavigationState);
				instance.on('update', updateNavigationState);
				updateNavigationState();
			}
		});


		//const owl_d = $('.__owl_destinations');
		//const owl_t = $('.__owl_team');
		//const owl_p = $('.__owl_partenaires');

		// this.initOwlCarousel(owl_d, {
		//     loop: true,
		//     autoplay: true,
		//     touchDrag: true,
		//     autoplayHoverPause: true,
		//     autoplayTimeout: 3000,
		//     autoplaySpeed: 1500,
		//     responsive: {
		//         0: {items: 1.2, stagePadding: 7, dots: false, autoplay: false},
		//         600: {items: 2.2, stagePadding: 15, dots: false, autoplay: false},
		//         700: {items: 2.3, stagePadding: 5, dots: false, autoplay: false},
		//         992: {stagePadding: 15, items: 3},
		//         1200: {items: 2, dots: true, autoplay: true},
		//         1400: {items: 2.3},
		//         1650: {items: 3.2},
		//     },
		//     onInitialized() {
		//         $('.__owl_destinations').removeClass('_hide');
		//     },
		// });

		// this.initOwlCarousel(owl_t, {
		//     loop: true,
		//     items: 6,
		//     autoplay: true,
		//     center: true,
		//     mouseDrag: false,
		//     touchDrag: true,
		//     autoplayHoverPause: true,
		//     autoplayTimeout: 3000,
		//     autoplaySpeed: 1000,
		//     responsive: {
		//         0: {items: 2, dots: false, autoplay: false},
		//         600: {items: 3, dots: false, autoplay: false},
		//         900: {items: 4},
		//         1400: {items: 5},
		//     },
		// });
		//
		// this.initOwlCarousel(owl_p, {
		//     loop: true,
		//     items: 6,
		//     lazyLoad: true,
		//     autoplay: true,
		//     mouseDrag: false,
		//     touchDrag: true,
		//     autoplayHoverPause: true,
		//     autoplayTimeout: 3000,
		//     autoplaySpeed: 1000,
		//     responsive: {
		//         0: {items: 2},
		//         400: {items: 3},
		//         700: {items: 4},
		//         900: {items: 5},
		//         1200: {items: 6},
		//         1500: {items: 8},
		//     },
		// });
	},

	// A SUPPRIMER AVEC MAP
	map() {
		if (window.navigatorUtils.checkMobile()) {
			$('._col_contain_map').remove();
		} else {
			$(document).on('mouseover', '._area,._label_map', function () {
				const area = $(this).data('area');
				$(`._area[data-area=${area}], ._label_map[data-area=${area}]`).addClass('_hover');
			});

			$(document).on('mouseleave', '._area,._label_map', function () {
				const area = $(this).data('area');
				$('._area,._label_map').removeClass('_hover');
			});
		}
	},

	// PARTNERS
	partners() {

		initSwiper('.swiper_partners', {
			loop: true,
			slidesPerView: "auto",
			spaceBetween: 10,
			navigation: true,
			autoplay: true,
			autoHeight: true,
			watchOverflow: true
		});

	},

	// LAST MINUTES
	lastminutes() {

		this.bindLastMinuteFilters();
		this.updateProductAvailabilities();

	},

	initLastMinuteSwiper() {
		if (this.swiper_last && typeof this.swiper_last.destroy === 'function') {
			this.swiper_last.destroy(true, true);
		}

		this.swiper_last = initSwiper('._swiper_last_minute', {
			loop: false,
			slidesPerView: 1.2,
			spaceBetween: 10,
			navigation: true,
			navigationEls: {
				prevEl: '.__lastminute_prev',
				nextEl: '.__lastminute_next',
			},
			autoplay: false,
			autoHeight: true,
			watchOverflow: true,
			breakpoints: {
				0: { slidesPerView: 1.2 },
				765: { slidesPerView: 1.8 },
				960: { slidesPerView: 2.7 },
				1200:{ slidesPerView: 3.1 },
				1450:{ slidesPerView: 3.5 },
				1600:{ slidesPerView: 4.2 },
			},
		});
	},

	bindLastMinuteFilters() {
		$(document)
			.off('click.lastMinuteFilters click.lastMinuteFiltersClose')
			.on('click.lastMinuteFilters', '.__last_filter_toggle', function (event) {
				event.preventDefault();
				const filter = $(this).closest('.__last_filter');
				$('.__last_filter').not(filter).removeClass('_open');
				filter.toggleClass('_open');
			})
			.on('click.lastMinuteFilters', '.__last_filter_option', (event) => {
				event.preventDefault();
				const option = event.currentTarget;
				const filter = option.closest('.__last_filter');
				const filterName = filter?.dataset.filter;

				if (!filterName) return;

				this.lastMinuteFilters[filterName] = option.dataset.value || 'all';
				filter.querySelector('.__last_filter_toggle span').textContent = option.textContent.trim();
				filter.querySelectorAll('.__last_filter_option').forEach(item => item.classList.remove('_active'));
				option.classList.add('_active');
				filter.classList.remove('_open');

				this.applyLastMinuteFilters();
			})
			.on('click.lastMinuteFiltersClose', (event) => {
				if (!event.target.closest('.__last_filter')) {
					$('.__last_filter').removeClass('_open');
				}
			});
	},

	async updateProductAvailabilities() {
		const products = document.querySelectorAll(".__bl_produit[data-last-minute]");
		const productCodes = Array.from(products).map(item => item.getAttribute("data-product")).filter(Boolean);

		if (productCodes.length === 0) {
			this.showLastMinuteSection();
			return;
		}

		try {
			const response = await axios.post(
				`${_SITE_URL}get-products-availability`,
				qs.stringify({productCodes}),
				{
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
						'X-Requested-With': 'XMLHttpRequest'
					}
				}
			);

			const data = response.data || {};

			products.forEach(item => {
				const productCode = item.getAttribute("data-product");
				if (data[productCode] && data[productCode].places > 0) {
					const productData = data[productCode];

					item.querySelector(".lm-date").innerHTML = productData.date;
					item.querySelector(".lm-hour").innerHTML = productData.hour;
					item.querySelector(".lm-nb-places").innerHTML = productData.places;
					item.querySelector("._load").style.display = "none";
				} else {
					item.parentElement.remove();
				}
			});

			const slides = Array.from(document.querySelectorAll('._swiper_last_minute .swiper-slide'));
			slides.sort((a, b) => {
				const placesA = parseInt(a.querySelector('.lm-nb-places')?.textContent) || 0;
				const placesB = parseInt(b.querySelector('.lm-nb-places')?.textContent) || 0;
				return placesB - placesA;
			});
			this.lastMinuteSlides = slides.map(slide => slide.cloneNode(true));
			this.buildLastMinuteFilters();
			this.applyLastMinuteFilters();
		} catch (error) {
			console.error("Erreur lors de la recuperation des disponibilites :", error);
			this.lastMinuteSlides = Array.from(document.querySelectorAll('._swiper_last_minute .swiper-slide'))
				.map(slide => slide.cloneNode(true));
			this.initLastMinuteSwiper();
			this.showLastMinuteSection();
		}
	},

	buildLastMinuteFilters() {
		const destinations = new Map();
		const durations = new Map();

		this.lastMinuteSlides.forEach(slide => {
			const destId = slide.dataset.dest;
			const destLabel = slide.dataset.destLabel;
			const duration = slide.dataset.duration;

			if (destId && destLabel) destinations.set(destId, destLabel);
			if (duration) durations.set(duration, duration);
		});

		this.renderLastMinuteFilter('destination', 'Destination', 'All destinations', destinations);
		this.renderLastMinuteFilter('duration', 'Duration', 'All durations', durations);
	},

	renderLastMinuteFilter(filterName, defaultLabel, allLabel, options) {
		const filter = document.querySelector(`.__last_filter[data-filter="${filterName}"]`);
		const menu = filter?.querySelector('.__last_filter_menu');
		const label = filter?.querySelector('.__last_filter_toggle span');

		if (!filter || !menu || !label) return;

		const activeValue = options.has(this.lastMinuteFilters[filterName]) ? this.lastMinuteFilters[filterName] : 'all';
		this.lastMinuteFilters[filterName] = activeValue;
		label.textContent = activeValue === 'all' ? defaultLabel : options.get(activeValue);
		menu.innerHTML = '';

		const items = new Map([['all', allLabel], ...options]);
		items.forEach((optionLabel, value) => {
			const button = document.createElement('button');
			button.type = 'button';
			button.className = `__last_filter_option${value === activeValue ? ' _active' : ''}`;
			button.dataset.value = value;
			button.innerHTML = `<span></span>${optionLabel}`;
			menu.appendChild(button);
		});

		filter.style.display = options.size > 0 ? '' : 'none';
	},

	applyLastMinuteFilters() {
		const wrapper = document.querySelector('._swiper_last_minute .swiper-wrapper');
		if (!wrapper) return;

		const filteredSlides = this.lastMinuteSlides.filter(slide => {
			const destinationMatch = this.lastMinuteFilters.destination === 'all' || slide.dataset.dest === this.lastMinuteFilters.destination;
			const durationMatch = this.lastMinuteFilters.duration === 'all' || slide.dataset.duration === this.lastMinuteFilters.duration;
			return destinationMatch && durationMatch;
		});

		wrapper.innerHTML = '';
		filteredSlides.forEach(slide => wrapper.appendChild(slide.cloneNode(true)));
		this.initLastMinuteSwiper();
		this.showLastMinuteSection();
	},

	showLastMinuteSection() {
		document.querySelector('.__ophorus_acc_last_minute')?.classList.remove('_loading_availabilities');
	},
	///////////////////////////////////////////////////////////////////////////////////
	//
	//
	//   POPULAR TOURS
	//
	//
	///////////////////////////////////////////////////////////////////////////////////

	popularDestionations() {

		let _this = this;
		this.popularDest = $("._popular_dest._activ").data("dest");
		this.getPopularDestinations();

		$(document).on("click", "._popular_dest", function () {
			var _id = $(this).data("dest");
			if (_id != _this.popularDest) {
				$("._popular_dest").removeClass("_activ");
				$("._popular_dest").attr("aria-selected", "false");
				$(this).addClass("_activ").attr("aria-selected", "true");
				const nav = this.closest('.__section_nav');
				if (nav) {
					const navRect = nav.getBoundingClientRect();
					const activeRect = this.getBoundingClientRect();
					nav.style.setProperty('--section-nav-indicator-left', `${activeRect.left - navRect.left + nav.scrollLeft}px`);
					nav.style.setProperty('--section-nav-indicator-width', `${activeRect.width}px`);
				}
				_this.popularDest = _id;
				_this.getPopularDestinations();
			}

		});
	},

	async getPopularDestinations() {
		try {
			// Appel Ajax via la fonction centralisée
			const response = await ajaxRequest(`${_SITE_URL}get-home-destinations-popular`, {
				dest_id: this.popularDest
			});

			// Gestion de la réponse
			if (response !== "empty") {
				setTimeout(() => {
					const popularDestinations = document.querySelector(".__popular_destinations");
					popularDestinations.innerHTML = response;
					this.initPopularProductsSwiper();

					if (common.$windowW < 768) {
						// Ajoutez votre logique de mise à jour pour mobile ici
					} else {
						this.heightminPopular = popularDestinations.offsetHeight;
					}
				}, 400);
			} else {
				console.warn("Aucune destination populaire disponible.");
			}
		} catch (error) {
			console.error("Erreur lors du chargement des destinations populaires :", error);
		}
	},

	// Le contenu de .__popular_destinations est entierement remplace
	// (innerHTML) a chaque changement d'onglet destination : l'instance
	// Swiper precedente pointe alors sur des noeuds DOM detruits et doit etre
	// recreee a chaque fois, meme pattern que initLastMinuteSwiper().
	initPopularProductsSwiper() {
		if (this.popularProductsSwiper && typeof this.popularProductsSwiper.destroy === 'function') {
			this.popularProductsSwiper.destroy(true, true);
			this.popularProductsSwiper = null;
		}

		const container = document.querySelector('.__popular_products_swiper');
		if (!container) return;

		this.popularProductsSwiper = initSwiper('.__popular_products_swiper', {
			loop: false,
			slidesPerView: 1.2,
			// Les slides (._wrap_produit) portent deja leur propre gouttiere
			// (padding, cf. _ophorus_bloc_produit.scss) - spaceBetween a 0
			// partout pour ne pas la doubler.
			spaceBetween: 0,
			navigation: true,
			navigationEls: {
				prevEl: '.__popular_products_prev',
				nextEl: '.__popular_products_next',
			},
			autoplay: false,
			watchOverflow: true,
			// 8 produits par destination (limit=8 cote controleur) : environ 3,6
			// cartes en grand ecran pour conserver une largeur confortable tout
			// en laissant l'apercu de la suivante signaler le carrousel.
			breakpoints: {
				0: {slidesPerView: 1.2},
				640: {slidesPerView: 2.2},
				993: {slidesPerView: 3.2},
				1300: {slidesPerView: 3.6},
			},
		});

		const prevBtn = document.querySelector('.__popular_products_prev');
		const nextBtn = document.querySelector('.__popular_products_next');

		if (prevBtn && nextBtn && this.popularProductsSwiper) {
			const updateNavigationState = () => {
				prevBtn.classList.toggle('_disabled', this.popularProductsSwiper.isBeginning);
				nextBtn.classList.toggle('_disabled', this.popularProductsSwiper.isEnd);
			};

			this.popularProductsSwiper.on('slideChange', updateNavigationState);
			this.popularProductsSwiper.on('resize', updateNavigationState);
			this.popularProductsSwiper.on('update', updateNavigationState);
			updateNavigationState();
		}
	},

	getDestination(id) {
		$.ajax({
			url: `${_SITE_URL}get-home-destinations`,
			type: 'post',
			data: {dest_id: id},
			beforeSend() {
				console.log(`Request is being sent for destination ID: ${id}`);
			},
			success(response) {
				// Handle success
				console.log(response);
			},
			error(xhr, status, error) {
				console.error('AJAX Error:', status, error);
			},
		});
	},
};

export default home;
